/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function () {
  'use strict';
  var root = document.querySelector('[data-eksplorator-losowan]');
  if (!root) return;
  var en = /^en(?:-|$)/i.test(document.documentElement.lang || '');
  var status = root.querySelector('[data-eksplorator-status]');
  function komunikat(pl, ang) { if (status) status.textContent = en ? ang : pl; }
  function kopiuj() {
    var url = location.href;
    var p = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(url) : Promise.reject();
    p.then(function () { komunikat(jst("ui.d9f78f053485dd37"), jst("ui.71af38a2d56ba6ab")); }).catch(function () {
      window.prompt(jst("pages_eksplorator_akcje_js.c53915d6e825"), url);
    });
  }
  function csv() {
    var table = root.querySelector('table');
    if (!table || !window.PewniakiStatV2 || typeof window.PewniakiStatV2.csv !== 'function') return;
    var rows = Array.prototype.map.call(table.querySelectorAll('tr'), function (row) {
      return Array.prototype.map.call(row.querySelectorAll('th,td'), function (cell) {
        var clean = cell.cloneNode(true);
        clean.querySelectorAll('.tabela__sort-znak').forEach(function (sign) { sign.remove(); });
        var balls = clean.querySelectorAll('.kula');
        if (balls.length) return Array.prototype.map.call(balls, function (ball) { return ball.textContent.trim(); }).join(' ');
        return clean.textContent.replace(/\s+/g, ' ').trim();
      });
    });
    var blob = new Blob([window.PewniakiStatV2.csv({naglowki:rows.shift() || [], wiersze:rows})], { type: 'text/csv;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'eksplorator-losowan.csv';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
    komunikat(jst("pages_eksplorator_akcje_js.literal.99eb9c942f71"), jst("ui.5abcec580b0f33e1"));
  }
  var copy = root.querySelector('[data-eksplorator-kopiuj]');
  var exportButton = root.querySelector('[data-eksplorator-csv]');
  if (copy) copy.addEventListener('click', kopiuj);
  if (exportButton) exportButton.addEventListener('click', csv);
}());
